<div class="calendar-view-filters">
  <!-- Update Button -->
  <div class="form-group mat-elevation-z4 w-100">
    <mat-form-field class="full-width-input">
      <mat-label>Type</mat-label>
      <mat-select [(value)]="filters.calendarViewOption" (selectionChange)="filters.calendarViewOption = $event.source.value; updateFilters()">
        <mat-option
          *ngFor="let type of calendarViewOptions"
          [value]="type.value"
          options-id="codeTypes"
          [option]="constantize(type.display)"
          >
          {{type.display}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div *ngIf="filters.calendarViewOption === CalendarViewOptionEnum.REACTIONS" class="form-group mat-elevation-z4">
    <div class="form-group">
      <label for="ReactionOptions">Reactions</label>
      <app-multiple-select
        id="ReactionOptions"
        allSelectedString="All Reactions"
        [useListStyle]="true"
        [scrollOverflow]="false"
        [useAutocomplete]="false"
        [showListControlButtons]="false"
        [allByDefault]="true"
        [allSelectedEqualsNull]="false"
        [options]="dropdownData.reactionOptions"
        [selected]="filters.reactionIds"
        (selectedUpdated)="filters.reactionIds = $event.map(parseStringIdToNumber); updateFilters()" />
    </div>
  </div>

  <div *ngIf="filters.calendarViewOption === CalendarViewOptionEnum.BELL_SCHEDULES" class="form-group mat-elevation-z4">
    <div class="form-group">
      <label for="BellScheduleOptions">Bell Schedules</label>
      <app-multiple-select
        id="BellScheduleOptions"
        allSelectedString="All Bell Schedules"
        [useListStyle]="true"
        [scrollOverflow]="false"
        [useAutocomplete]="false"
        [showListControlButtons]="false"
        [allByDefault]="true"
        [allSelectedEqualsNull]="false"
        [options]="dropdownData.bellScheduleOptions"
        [selected]="filters.bellScheduleIds"
        (selectedUpdated)="filters.bellScheduleIds = $event.map(parseStringIdToNumber); updateFilters()" />
    </div>
    <div class="form-group">
      <label for="BellScheduleOptions">Student Groups</label>
      <app-multiple-select
        id="StudentGroupsOptions"
        allSelectedString="All Student Groups"
        [useListStyle]="true"
        [scrollOverflow]="false"
        [useAutocomplete]="false"
        [showListControlButtons]="false"
        [allByDefault]="true"
        [allSelectedEqualsNull]="false"
        [options]="dropdownData.studentGroupOptions"
        [selected]="filters.studentGroupIds"
        (selectedUpdated)="filters.studentGroupIds = $event.map(parseStringIdToNumber); updateFilters()" />
    </div>
  </div>

  <div *ngIf="filters.calendarViewOption === CalendarViewOptionEnum.EVENTS" class="form-group mat-elevation-z4">
    <div class="form-group">
      <mat-form-field class="full-width-input filter-item">
        <mat-label>Filter by Event Category</mat-label>
        <mat-select
          multiple
          [value]="filters.heroEventCategoryIds"
          (selectionChange)="filters.heroEventCategoryIds = $event.value.map(parseStringIdToNumber); updateFilters()"
        >
          <mat-option *ngFor="let option of dropdownData.eventCategoryOptions" [value]="option.value">
            {{ option.display }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <label for="EventOptions">Events</label>
      <app-multiple-select
        id="EventOptions"
        allSelectedString="All Events"
        [useListStyle]="true"
        [scrollOverflow]="false"
        [useAutocomplete]="false"
        [showListControlButtons]="false"
        [allByDefault]="true"
        [allSelectedEqualsNull]="false"
        [options]="dropdownData.heroEventOptions"
        [selected]="filters.heroEventIds"
        (selectedUpdated)="filters.heroEventIds = $event.map(parseStringIdToNumber); updateFilters()" />
    </div>
  </div>
</div>
